var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"uppercase box-shadow-network"},[_c('img',{attrs:{"height":"24","width":"24","src":require("../assets/img/logo-US.png")}}),(!_vm.isSmall)?_c('span',[_vm._v("Continuer avec United Schools")]):_c('span',[_vm._v("United Schools")])])
}
var staticRenderFns = []

export { render, staticRenderFns }